/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetVendorsQuery } from '../../models/get-vendors-query';
import { GetVendorsQueryResult } from '../../models/get-vendors-query-result';

export interface ApiVendorsGetVendorsPost$Plain$Params {
  
    /**
     * The query parameters for fetching Vendor .
     */
    body?: GetVendorsQuery
}

export function apiVendorsGetVendorsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiVendorsGetVendorsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVendorsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiVendorsGetVendorsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetVendorsQueryResult>;
    })
  );
}

apiVendorsGetVendorsPost$Plain.PATH = '/api/Vendors/GetVendors';
